export default "__VITE_ASSET__49faf9a3__"